import { toast } from '@/ui/UiToaster';
import { config } from '@/auth/config';
import { SCORE_URL } from "./constants";
import { AuthResponse, TokenResponse } from "./types";

export const getUserScore = async (backendUrl: string, ksid = '', client_id: string, gid: string): Promise<any | void> => {
  const url = `${backendUrl}${SCORE_URL}`;

  const data = {
    ksid,
    client_id,
    gid,
    step: '',
  };

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(data)
    })
    return await response.json();

  } catch (error: unknown) {
    console.error('Ошибка в getUserInfo:', error);
  }
};

export const handleFetchToken = async ({
  code = '',
  state = '',
  ksid = undefined,
}: AuthResponse): Promise<TokenResponse | undefined> => {
  try {
    // TODO добавить значения из семпла
    const { clientId, backendUrl } = config;
    const url = `${backendUrl}/api/v0.3/backend/oauth/token`;
    const { origin, pathname } = window.location;
    const data: Record<string, string | undefined> = {
      client_id: clientId,
      grant_type: 'authorization_code_otp',
      redirect_uri: origin + pathname,
      state,
      code,
      ksid,
    };
    const params: RequestInit = {
      method: 'POST',
      cache: 'no-cache',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
      mode: 'cors',
    };
    const response = await fetch(url, params);
    return await response.json();
  } catch (error) {
    if (error instanceof Error) {
      toast.error(error.message);
    }
  }
};